import { render } from "./Logistics.vue?vue&type=template&id=268ef164&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=268ef164&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268ef164"]])

export default __exports__